import React from "react";
import "./Main.css";
import TextSketch from "./images/Vector.svg";
const TopSection = () => {
  return (
    <div className="services__top-section">
      <div>
        <div className="services__top-section-header">
          <header>
            <h3>
              We build software
              <div className="services__header-text-sketch">
                <img src={TextSketch} alt="" />
              </div>{" "}
              that scales
            </h3>
            <p>
              Web and mobile products for commerce and payments. We take on
              selected projects where a partner needs a product built or
              extended by an experienced team.
            </p>
          </header>
        </div>
      </div>
    </div>
  );
};

export default TopSection;
